// src/utils/draftCompare.ts
//
// The confirm-step DISPLAY helper (Story 4.3). The server computes the record
// value `sent_unedited` inside tx_respond (AD-8 — never client-supplied); this
// helper only decides the human copy shown in the send-confirm step, mirroring
// the server rule so the two can't drift:
//   * a draft-derived FIRST response ⇒ "Sent unedited from Yak's draft" /
//     "Edited from Yak's draft" by btrim-equality
//   * draftless, or a follow-up (not the first response) ⇒ no edited/unedited
//     line at all (null) — those are excluded from the edit-rate denominator.
// It is display-only: the message row's server value is the record 5.1/5.3 read.

export type DraftEditState = 'unedited' | 'edited' | null

// draftEditedForDisplay — mirror of tx_respond's sent_unedited rule for the
// confirm step. `draft` is the ticket's stored draft (null when none);
// `isFirstResponse` is true only when the ticket has no prior response message.
export function draftEditedForDisplay(
  draft: string | null,
  body: string,
  isFirstResponse: boolean
): DraftEditState {
  if (draft === null || !isFirstResponse) return null
  return draft.trim() === body.trim() ? 'unedited' : 'edited'
}

// The one-line human copy for a DraftEditState (null ⇒ no line rendered).
export function draftEditStateLabel(state: DraftEditState): string | null {
  switch (state) {
    case 'unedited':
      return "Sent unedited from Yak's draft"
    case 'edited':
      return "Edited from Yak's draft"
    case null:
      return null
  }
}
